export const OPEN_BETS_TAB_ID = 'open_bets';
